import { Filter } from './../../process/ajax-collection-v3';

export class CustomAvailabilityFilter extends Filter {
  constructor(template, handle, available) {
    super(template,handle);

    // Set initial availability
    this.available = available || false;
  }

  getSettings() {
    if(this.available) return "yes";
    return null;
  }

  getSetting() { return this.available; }

  setSetting(key, value) {
    return this.setAvailability(value);
  }

  setSettings(value) {
    return this.setAvailability(value);
  }

  setAvailability(value) {
    if(Array.isArray(value)) value = value[0];
    if(this.getSetting(value) === value) return;
    if(value === null) value = false;
    this.available = value !== false && value !== "no";
    this.filters.onFilterUpdate();
  }

  filter(p, v) {
    if(!this.available) return true;
    return v.inventory_quantity > 0;
  }
}